import { Link } from "react-router-dom";
import { useAuth } from "../../../providers/Auth";
import { TableContainer } from "./styles";
import { ReactSVG } from "react-svg";
import ativo from "../../../assets/ativo.svg";
import inativo from "../../../assets/inativo.svg";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import { toast } from "react-toastify";

const Table = ({ perfilSelecionado, textoPesquisa }) => {
  const [permissoes, setPermissoes] = useState([]);

  function buscarPermissoes() {
    api
      .get("/permissoes")
      .then((response) => {
        setPermissoes(response.data.data.permissoes);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  }

  useEffect(() => {
    buscarPermissoes();
  }, []);

  const colunas = ["Id", "Nome", "Status"];
  const filtrarPermissao = (permissao) => {
    const perfilFiltrado =
      !perfilSelecionado || permissao.status === parseInt(perfilSelecionado);
    const pesquisaFiltrada =
      !textoPesquisa ||
      permissao.nome.toLowerCase().includes(textoPesquisa.toLowerCase());
    const idPermissao = parseInt(textoPesquisa);
    const idFiltrado = !isNaN(idPermissao) && permissao.id === idPermissao;

    return perfilFiltrado && (pesquisaFiltrada || idFiltrado);
  };

  const permissoesFiltradas = permissoes.filter(filtrarPermissao);

  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {colunas.map((coluna) => (
              <th key={coluna}>{coluna}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {permissoesFiltradas.map((lista) => (
            <tr className="map" key={lista.id}>
              <td>#{lista.id}</td>
              <td>{lista.nome}</td>

              {lista.status === 1 ? (
                <td>
                  <div className="ativo">
                    <ReactSVG src={ativo} />
                    <p>ativo</p>
                  </div>
                </td>
              ) : (
                <td>
                  <div className="ativo">
                    <ReactSVG src={inativo} />
                    <p>inativo</p>
                  </div>
                </td>
              )}

              <td className="td-editar">
                <Link
                  to={`/permissao/editar/${lista.id}`}
                  className="editar"
                  htmlFor="editar"
                >
                  Abrir
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default Table;
